import { render } from "./depa.vue?vue&type=template&id=78e6d9fb"
import script from "./depa.vue?vue&type=script&lang=js"
export * from "./depa.vue?vue&type=script&lang=js"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__